import { useTranslation } from 'react-i18next';
import Select from '__components/Inputs/Select';
import { getDataQAForInput } from 'components/Inputs/helpers';
import { useErrors } from 'pages/SmartConnectors/SmartConnector/hooks/useErrors';
import { FC, useContext, useMemo } from 'react';
import { SmartConnectorContext } from '../../context';

type WebhookCadenceSelectProps = {
  value: number | undefined;
  onChange: (value: number) => void;
};

export const WebhookCadenceSelect: FC<WebhookCadenceSelectProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const { metaData } = useContext(SmartConnectorContext);

  const { clearError, validate, error } = useErrors('webhook_cadence');

  const options = useMemo(() => {
    return metaData?.webhook_cadence_choices.map(([value, label]) => ({
      label,
      value,
    }));
  }, [metaData]);

  const handleChange = ({ value }: { value: string }) => {
    onChange(parseInt(value));
    clearError();
  };

  return (
    <Select
      label={t('Process New Webhooks Every')}
      value={String(value)}
      onChange={handleChange}
      options={options}
      margin
      error={error}
      validate={validate}
      {...getDataQAForInput('smart-connector-webhook-cadence', 'dropdown')}
    />
  );
};
